/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Competitive_4_TitleInputs */

const en_about_content_competitive_4_title = /** @type {(inputs: About_Content_Competitive_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR competitor`)
};

const es_about_content_competitive_4_title = /** @type {(inputs: About_Content_Competitive_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Competidor del PGA TOUR`)
};

const de_about_content_competitive_4_title = /** @type {(inputs: About_Content_Competitive_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spieler auf der PGA TOUR`)
};

const zh_about_content_competitive_4_title = /** @type {(inputs: About_Content_Competitive_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`美巡赛参赛球员`)
};

const ar_about_content_competitive_4_title = /** @type {(inputs: About_Content_Competitive_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`منافس في PGA TOUR`)
};

const fr_about_content_competitive_4_title = /** @type {(inputs: About_Content_Competitive_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joueur du PGA TOUR`)
};

const vi_about_content_competitive_4_title = /** @type {(inputs: About_Content_Competitive_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tay golf thi đấu PGA TOUR`)
};

const sw_about_content_competitive_4_title = /** @type {(inputs: About_Content_Competitive_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mshindani wa PGA TOUR`)
};

const th_about_content_competitive_4_title = /** @type {(inputs: About_Content_Competitive_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผู้แข่งขันบน PGA TOUR`)
};

const bs_about_content_competitive_4_title = /** @type {(inputs: About_Content_Competitive_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takmičar na PGA TOUR-u`)
};

const ja_about_content_competitive_4_title = /** @type {(inputs: About_Content_Competitive_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGAツアー出場経験`)
};

const ko_about_content_competitive_4_title = /** @type {(inputs: About_Content_Competitive_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR 출전 선수`)
};

const pt_about_content_competitive_4_title = /** @type {(inputs: About_Content_Competitive_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogador do PGA TOUR`)
};

const it_about_content_competitive_4_title = /** @type {(inputs: About_Content_Competitive_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giocatore del PGA TOUR`)
};

const sv_about_content_competitive_4_title = /** @type {(inputs: About_Content_Competitive_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spelare på PGA TOUR`)
};

const nl_about_content_competitive_4_title = /** @type {(inputs: About_Content_Competitive_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speler op de PGA TOUR`)
};

const da_about_content_competitive_4_title = /** @type {(inputs: About_Content_Competitive_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spiller på PGA TOUR`)
};

const nb_about_content_competitive_4_title = /** @type {(inputs: About_Content_Competitive_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spiller på PGA TOUR`)
};

const fi_about_content_competitive_4_title = /** @type {(inputs: About_Content_Competitive_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR -pelaaja`)
};

const pl_about_content_competitive_4_title = /** @type {(inputs: About_Content_Competitive_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zawodnik PGA TOUR`)
};

const ru_about_content_competitive_4_title = /** @type {(inputs: About_Content_Competitive_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Участник PGA TOUR`)
};

const tr_about_content_competitive_4_title = /** @type {(inputs: About_Content_Competitive_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR oyuncusu`)
};

const hi_about_content_competitive_4_title = /** @type {(inputs: About_Content_Competitive_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR प्रतियोगी`)
};

const id_about_content_competitive_4_title = /** @type {(inputs: About_Content_Competitive_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemain PGA TOUR`)
};

const ms_about_content_competitive_4_title = /** @type {(inputs: About_Content_Competitive_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peserta PGA TOUR`)
};

const cs_about_content_competitive_4_title = /** @type {(inputs: About_Content_Competitive_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hráč PGA TOUR`)
};

const el_about_content_competitive_4_title = /** @type {(inputs: About_Content_Competitive_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Παίκτης του PGA TOUR`)
};

const he_about_content_competitive_4_title = /** @type {(inputs: About_Content_Competitive_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מתחרה ב-PGA TOUR`)
};

const af_about_content_competitive_4_title = /** @type {(inputs: About_Content_Competitive_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR-speler`)
};

const hu_about_content_competitive_4_title = /** @type {(inputs: About_Content_Competitive_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA TOUR-versenyző`)
};

/**
* | output |
* | --- |
* | "PGA TOUR competitor" |
*
* @param {About_Content_Competitive_4_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_competitive_4_title = /** @type {((inputs?: About_Content_Competitive_4_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Competitive_4_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_competitive_4_title(inputs)
	if (locale === "de") return de_about_content_competitive_4_title(inputs)
	if (locale === "zh") return zh_about_content_competitive_4_title(inputs)
	if (locale === "ar") return ar_about_content_competitive_4_title(inputs)
	if (locale === "fr") return fr_about_content_competitive_4_title(inputs)
	if (locale === "vi") return vi_about_content_competitive_4_title(inputs)
	if (locale === "sw") return sw_about_content_competitive_4_title(inputs)
	if (locale === "th") return th_about_content_competitive_4_title(inputs)
	if (locale === "bs") return bs_about_content_competitive_4_title(inputs)
	if (locale === "ja") return ja_about_content_competitive_4_title(inputs)
	if (locale === "ko") return ko_about_content_competitive_4_title(inputs)
	if (locale === "pt") return pt_about_content_competitive_4_title(inputs)
	if (locale === "it") return it_about_content_competitive_4_title(inputs)
	if (locale === "sv") return sv_about_content_competitive_4_title(inputs)
	if (locale === "nl") return nl_about_content_competitive_4_title(inputs)
	if (locale === "da") return da_about_content_competitive_4_title(inputs)
	if (locale === "nb") return nb_about_content_competitive_4_title(inputs)
	if (locale === "fi") return fi_about_content_competitive_4_title(inputs)
	if (locale === "pl") return pl_about_content_competitive_4_title(inputs)
	if (locale === "ru") return ru_about_content_competitive_4_title(inputs)
	if (locale === "tr") return tr_about_content_competitive_4_title(inputs)
	if (locale === "hi") return hi_about_content_competitive_4_title(inputs)
	if (locale === "id") return id_about_content_competitive_4_title(inputs)
	if (locale === "ms") return ms_about_content_competitive_4_title(inputs)
	if (locale === "cs") return cs_about_content_competitive_4_title(inputs)
	if (locale === "el") return el_about_content_competitive_4_title(inputs)
	if (locale === "he") return he_about_content_competitive_4_title(inputs)
	if (locale === "af") return af_about_content_competitive_4_title(inputs)
	if (locale === "hu") return hu_about_content_competitive_4_title(inputs)
	return en_about_content_competitive_4_title(inputs)
});